import {debounce} from '@malt/common/src/utils/debounce';
import {screenSm} from '../utils/medias/media-queries';

Hop.defineModule('mobile-filters', (root) => {
    const $body = document.body;
    const $filterCTA = root.querySelector('[data-show-filters]');
    const $checkboxes = root.querySelectorAll('[type="checkbox"]');
    const $submitCta = root.querySelector('button[type="submit"]');
    const $resetCta = root.querySelector('button[type="reset"]');
    const $closeCta = root.querySelector('[data-close-filters]');
    const $filtersWrapper = root.querySelector('[data-filters-wrapper]');
    const debounceResize = debounce(reset, 50);

    function check(condition, msg) {
        if (condition) {
            throw new Error(msg());
        }
    }

    check(!$filterCTA, () => 'Missing data-show-filters element');
    check(!$filtersWrapper, () => 'Missing data-filters-wrapper element');
    check(!$submitCta, () => 'Missing button[type="submit"] element');

    const initialState = new Map();

    function keyOf($checkbox) {
        const name = $checkbox.name;
        const value = $checkbox.value;
        return `${name}::${value}`;
    }

    function clearInitialState() {
        initialState.clear();
    }

    function storeInitialCheckboxState($checkbox) {
        initialState.set(keyOf($checkbox), $checkbox.checked);
    }

    function resetToInitialCheckboxState($checkbox) {
        $checkbox.checked = initialState.get(keyOf($checkbox)) || false;
    }

    function storeInitialState() {
        clearInitialState();

        $checkboxes.forEach(($checkbox) => storeInitialCheckboxState($checkbox));
    }

    function resetToInitialState() {
        $checkboxes.forEach(($checkbox) => resetToInitialCheckboxState($checkbox));
    }

    function show() {
        $filtersWrapper.classList.add('active');
        $body.classList.add('no-scroll');
    }

    function hide() {
        $filtersWrapper.classList.remove('active');
        $body.classList.remove('no-scroll');
    }

    function close() {
        clearInitialState();
        hide();
    }

    function computeState() {
        const state = {};

        $checkboxes.forEach(($checkbox) => {
            if ($checkbox.checked) {
                const name = $checkbox.name;
                const value = $checkbox.value;

                if (!state[name]) {
                    state[name] = [];
                }

                state[name].push(value);
            }
        });

        return state;
    }

    function submit() {
        root.dispatchEvent(
            new CustomEvent('mobile-filters:change', {
                bubbles: true,
                detail: computeState(),
            }),
        );
    }

    function onShowFilters() {
        storeInitialState();
        show();
    }

    function onSubmit(e) {
        e.preventDefault();
        submit();
        close();
    }

    function onReset(e) {
        e.preventDefault();
        resetToInitialState();
        close();
    }

    function onClose(e) {
        e.preventDefault();
        resetToInitialState();
        close();
    }

    function reset() {
        if (screenSm('min')) {
            close();
        }
    }

    function listenToEvents() {
        $filterCTA.addEventListener('click', onShowFilters);
        $submitCta.addEventListener('click', onSubmit);

        if ($resetCta) {
            $resetCta.addEventListener('click', onReset);
        }

        if ($closeCta) {
            $closeCta.addEventListener('click', onClose);
        }

        window.addEventListener('resize', debounceResize);
    }

    function init() {
        listenToEvents();
    }

    init();

    return function destroy() {
        $filterCTA.removeEventListener('change', onShowFilters);
        $submitCta.removeEventListener('click', onSubmit);

        if ($resetCta) {
            $resetCta.removeEventListener('click', onReset);
        }

        if ($closeCta) {
            $closeCta.removeEventListener('click', onClose);
        }

        window.removeEventListener('resize', debounceResize);
    };
});
